<tui-root>
    <main class="px-0 md:px-8 xl:px-0 py-16">
    <section *ngIf="currentSurveyStep === 4">
        <div class="storenContainer mx-auto">

                <!-- <form class="bg-white px-0" [formGroup]="uploadForm"> -->
                    <form class="bg-white px-0">
                <div class="tui-row tui-row_sme justify-center items-center md:flex-row flex-col"
                    *ngIf="current_upload_inner_step == 1">
                    <div class="w-full row">
                        <div class="upload-container">

                            <div class="d-md-none d-block text-center p-4" id="cleanRows">
                                <p class="text-[30px] leading-[37px] font-semibold">Upload Assets</p>
                                <p class="text-[16px] leading-[24px] mt-2">Select and upload images or videos. You
                                    can
                                    select more
                                    than one, but only for this timing.</p>
                            </div>

                            <div class="d-md-block d-none my-4">
                                <label tuiInputFiles class="file-content-label bg-light d-flex align-items-center">
                                    <!-- <input tuiInputFiles [formControl]="fileControl" (change)="onFileUpload($event)" /> -->
                                    <input tuiInputFiles #fileInput [formControl]="fileControl" (change)="onFileUpload($event)"
                          accept="image/*, video/*" multiple />
                                    <ng-template let-dragged>
                                        <div *ngIf="dragged; else base" class="file-content">
                                            <tui-avatar appearance="secondary" src="@tui.droplet" />
                                            <div>Drop your photos here!</div>
                                        </div>
                                        <ng-template #base>
                                            <div class="file-content">
                                                <tui-avatar appearance="secondary" class="text-dark bg-gold-hover"
                                                    src="@tui.download" />
                                                <p class="text-[16px] font-weight-bold mb-0">Upload Images or Videos
                                                </p>
                                                <p>Please upload all images or videos you'd like to submit.<br> Drag and drop file(s) here or <a tuiLink
                                                        class="text-dark"><strong><u>Choose file(s)</u></strong></a>
                                                </p>
                                            </div>
                                        </ng-template>
                                    </ng-template>
                                </label>
                            </div>

                            <div *ngIf="uploadedFiles.length > 0" class="uploaded-assets">
                                <div *ngFor="let file of uploadedFiles; let i = index"
                                    class="file-item d-flex justify-content-between align-items-center p-1 rounded border" style="margin-top:3%">
                                    <div class="d-flex align-items-center gap-15">
                                        <tui-icon *ngIf="file.isVideo; else imageIcon" size="m"
                                            icon="@tui.video"></tui-icon>
                                        <ng-template #imageIcon>
                                            <tui-icon size="m" icon="@tui.image"></tui-icon>
                                        </ng-template>

                                        <div class="ml-2">
                                            <p class="text-dark mb-0 text-[14px] mobileFilenameDt">{{ file.file.name }}</p>
                                            <p class="text-muted mb-0 text-[12px] text-muted">
                                                {{ (file.file.size / 1024 / 1024).toFixed(2) }} mb
                                            </p>
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center">
                                        <tui-progress-circle *ngIf="file.progress < 100" [value]="file.progress"
                                            size="xs" [max]="100" [style.color]="(color$ | async) || 0" />

                                        <tui-progress-circle class="d-none" size="s" [max]="100"
                                            [value]="(value$ | async) || 0" />

                                        <tui-avatar *ngIf="file.progress === 100" size="s"
                                            class="font-weight-bold text-dark bg-transparent cursor-pointer"
                                            aria-label="Close" (click)="removeFile(i)" src="@tui.x"></tui-avatar>
                                    </div>
                                </div>
                            </div>

                        </div>


                        <div class="tui-form__row tui-form__row_multi-fields md:hidden dblock"
                            *ngIf="uploadedFiles.length == 0">
                            <div class="tui-form__buttons col-md-6 col-12 mt-0 px-0">
                                <!-- <button size="m" tuiButton iconStart="@tui.camera" appearance="primary-grayscale"
                                    type="button" (click)="selectImageVideos()"
                                    class="tui-form__button1 rounded-0 send-consent-btn w-100 dark-btn-hover">
                                    Select Image & Videos
                                </button> -->
                                <input type="file" #mobileFileInput [formControl]="fileControl" (change)="onFileUpload($event)"
                                style="display: none;" />
                              <button size="m" tuiButton iconStart="@tui.camera" appearance="primary-grayscale" type="button"
                                (click)="fileInput.click()"
                                class="tui-form__button1 rounded-0 send-consent-btn w-100 dark-btn-hover">
                                Select Image & Videos
                              </button>
                            </div>
                        </div>


                        <!-- Desktop -->
                        <div class="tui-form__row mt-4" *ngIf="uploadedFiles.length > 0 && allUploadsComplete">
                            <div class="tui-form__buttons w-1full mt-0 px-0">
                                <!-- <button size="m" tuiButton appearance="primary-grayscale" type="button"
                                   (click)="continueToDetails()"
                                    class="tui-form__button1 rounded-0 send-consent-btn w-100 dark-btn-hover">
                                    Continue To Details
                                </button> -->
                                <button size="m" tuiButton appearance="primary-grayscale" type="button"
                                [disabled]="hasNoUploadedFiles() || !allUploadsComplete" (click)="continueToDetails()"
                                class="rounded-0 text-white w-100 dark-btn-hover">
                                {{  hasNoUploadedFiles() ? 'Upload Assets Files' : 'Continue To Details' }}
                              </button>
                            </div>
                        </div>

                        <div class="tui-form__row d-md-none d-block mt-2" *ngIf="uploadedFiles.length > 0">
                            <div class="tui-form__buttons w-full mt-0 px-0">
                                <input type="file" #mobileFileInput [formControl]="fileControl" (change)="onFileUpload($event)"
                                style="display: none;" />
                              <button tuiButton iconStart="@tui.camera" appearance="textfield" size="m"
                                class="rounded-0 w-100 bg-transparent light-btn-hover" (click)="fileInput.click()">
                                Add More Images & Videos
                              </button>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="tui-row tui-row_sme align-items-center md-flex-row flex-column"
                    *ngIf="current_upload_inner_step == 2">
                    
                    <div class="w-full">
                        <ng-container *ngFor="let file of uploadedFiles; let k = index">
                        <div class="image_metadata-container" *ngIf="!file.isReadonly && !file.isDeleted">
                            <div class="row mx-0 p-3">
                                <!-- <div class="col-md-6 col-4 bg-secondary" *ngIf="!file.fileName.includes('heic')">
                                    <img [src]="file.fileUrl" controls class="preview-image">
                                </div>
                                <div class="col-md-6 col-4 bg-secondary" *ngIf="file.fileName.includes('heic')">
                                    <img src="../assets/no-preview.jpg" controls class="preview-image margin-adjustment">
                                </div> -->

                                <!-- <div class="col-md-6 col-4 bg-secondary image-container mb-img" [class.video]="file.isVideo"
                                [class.image]="!file.isVideo">
                                <tui-icon *ngIf="file.isVideo" class="position-absolute"
                                    style="top: 10px; left: 10px; z-index: 1; padding: 8px; border-radius: 50%; " size="s" icon="@tui.video">
                                </tui-icon>
                                <tui-icon *ngIf="!file.isVideo" class="position-absolute"
                                    style="top: 10px; left: 10px; z-index: 1; padding: 8px; border-radius: 50%; " size="s" icon="@tui.image">
                                </tui-icon>
                                <div *ngIf="!file.fileName.includes('heic')">
                                    <img [src]="file.fileUrl" controls class="preview-image">
                                </div>
                                <div *ngIf="file.fileName.includes('heic')">
                                    <img src="../assets/no-preview.jpg" controls class="preview-image margin-adjustment">
                                </div>
                               
                              </div> -->

                              <div class="col-md-6 col-4 bg-secondary image-container mb-img" [class.video]="file.isVideo"
                              [class.image]="!file.isVideo">
                              <tui-icon *ngIf="file.isVideo" class="position-absolute"
                                  style="top: 10px; left: 10px; z-index: 1; padding: 8px; border-radius: 50%; " size="s" icon="@tui.video">
                              </tui-icon>
                              <tui-icon *ngIf="!file.isVideo" class="position-absolute"
                                  style="top: 10px; left: 10px; z-index: 1; padding: 8px; border-radius: 50%; " size="s" icon="@tui.image">
                              </tui-icon>
                              <img [src]="file.fileUrl" controls class="preview-image" *ngIf="!file.fileName.includes('heic')">
                              <img src="../assets/no-preview.jpg" controls class="preview-image margin-adjustment" *ngIf="file.fileName.includes('heic')">
                          </div>



                                <div class="col-md-6 col-8">
                                    <div class="d-flex justify-content-between text-muted" style="overflow-wrap: anywhere;">
                                        <div class="file-name-wrap" class="col-9 pl-0 pr-0">{{file.fileName}}</div>
                            <div class="col-3 pr-0" style="font-weight:800;">{{k+1}} of {{uploadedFiles.length}}</div>
                                    </div>
                                    <div class="tui-form__row md:block hidden">
                                        <p class="text-[14px] mb-2">When did you apply Storen corn herbicide to this
                                            field?
                                            <span class="tui-required"></span>
                                        </p>
                                        <tui-input-date  name="applyStorenCornDate-{{k}}" [max]="maxDate" [(ngModel)]="uploadedFiles[k].trialAssetsDetails.applyStorenCornDate">00/00/00</tui-input-date>
                                    </div>
                                    <div class="tui-form__row">
                                        <p class="text-[14px] mb-2">Date of photo
                                            <span class="tui-required"></span>
                                        </p>
                                        <tui-input-date name="dateOfPhoto-{{k}}" [max]="maxDate" [(ngModel)]="uploadedFiles[k].trialAssetsDetails.dateOfPhoto">00/00/00</tui-input-date>
                                    </div>
                                    <div class="tui-form__row md:block hidden">
                                        <p class="text-[14px] mb-2">Use Rate<span class="tui-required"></span>
                                            (qt/A)
                                        </p>
                                  
                                      <tui-input [(ngModel)]="uploadedFiles[k].trialAssetsDetails.storenUseRate"
                                        name="storenUseRate-{{k}}"
                                        tuiHintContent="Enter rate (format: 00.00)">
                                        <input tuiTextfieldLegacy placeholder="00.00"
                                        (keydown)="restrictToNumbersAndDecimal($event, k)"
                                        (blur)="onRateInputBlur($event, k)" />
                                      </tui-input>

                                    </div>
                                </div>
                            </div>

                            <div class="row mx-0 p-3 md:hidden block">
                                <div class="tui-form__row">
                                    <p class="text-[14px] mb-2">When did you apply Storen corn herbicide to this
                                        field?
                                        <span class="tui-required"></span>
                                    </p>
                                    <tui-input-date  name="applyStorenCornDate-{{k}}"  [max]="maxDate"  [(ngModel)]="uploadedFiles[k].trialAssetsDetails.applyStorenCornDate">00/00/00</tui-input-date>
                                </div>
                                <div class="tui-form__row mobileMarginTop">
                                    <p class="text-[14px] mb-2">Use Rate<span class="tui-required"></span> (qt/A)
                                    </p>
                                   
                                      <tui-input [(ngModel)]="uploadedFiles[k].trialAssetsDetails.storenUseRate"
                                      name="storenUseRate-{{k}}"
                                      tuiHintContent="Enter rate (format: 00.00)">
                                      <input tuiTextfieldLegacy placeholder="00.00"
                                      (keydown)="restrictToNumbersAndDecimal($event, k)"
                                      (blur)="onRateInputBlur($event, k)" />
                                    </tui-input>
                                    

                                </div>
                            </div>

                            <div class="row mx-0 p-3">
                                <div class="flex md:flex-row flex-col px-0">
                                    <div class="col-md-9 col-12 desktopAlign">
                                        <p class="text-[14px] mb-2">Nearest city/town where this field is located
                                            <span class="tui-required"></span>
                                        </p>
                                        
                                      <tui-input name="storenNearestCity-{{k}}"  [(ngModel)]="uploadedFiles[k].trialAssetsDetails.storenNearestCity" tuiHintContent="A tooltip" tuiTextfieldSize="l">
                                        <input placeholder="City" tuiTextfieldLegacy />
                                      </tui-input>

                                    </div>
                                    <div class="col-md-3 col-12 mobileMarginTop">
                                        <p class="text-[14px] mb-2">State
                                            <span class="tui-required"></span>
                                        </p>
                                        <tui-combo-box tuiDropdownMobile  [(ngModel)]="uploadedFiles[k].trialAssetsDetails.storenState"
                                        name="storenState-{{k}}"  (tuiTextfieldCleanerClicked)="clearFormControl()">
                                            <tui-data-list-wrapper *tuiDataList
                                                [items]="stateList | tuiFilterByInput" />
                                        </tui-combo-box>
                                    </div>
                                </div>
                                <div class="w-100 mt-3 desktopAlign">
                                    <button (click)="confirmImageDetails(k)" tuiButton appearance="primary-grayscale"
                                        size="m" class="rounded-0 text-white w-100 dark-btn-hover" [disabled]="ischeckImageMandatoryFields(k)"
                                        iconStart="@tui.check">
                                        Confirm Image Details
                                    </button>
                                    <button (click)="deleteImage(k)" tuiButton appearance="flat-grayscale" size="m"
                                        class="rounded-0 text-dark w-100 my-3 light-btn-hover" iconStart="@tui.trash-2">
                                        Delete Image
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="image_metadata-container my-3" *ngIf="file.isReadonly && !file.isDeleted">
                            <div class="row mx-0 p-3">
                               
                                <div class="col-md-6 col-4 bg-secondary image-container mb-img" [class.video]="file.isVideo"
                                    [class.image]="!file.isVideo">
                                    <tui-icon *ngIf="file.isVideo" class="position-absolute"
                                        style="top: 10px; left: 10px; z-index: 1; padding: 8px; border-radius: 50%; " size="s" icon="@tui.video">
                                    </tui-icon>
                                    <tui-icon *ngIf="!file.isVideo" class="position-absolute"
                                        style="top: 10px; left: 10px; z-index: 1; padding: 8px; border-radius: 50%; " size="s" icon="@tui.image">
                                    </tui-icon>
                                    <img [src]="file.fileUrl" controls class="preview-image">
                                </div>
                                <div class="col-md-6 col-8">
                                    <div class="d-flex justify-content-between text-muted" style="overflow-wrap: anywhere;">
                                        <div class="file-name-wrap" class="col-9 pl-0 pr-0">{{file.fileName}}</div>
                                        <div class="col-3 pr-0" style="font-weight:800;">{{k+1}} of {{uploadedFiles.length}}</div>

                                    </div>
                                    <div class="mt-5">
                                        <p class="text-[16px] mb-2 font-weight-bold">Image details saved.</p>
                                        <button (click)="editDetails(k)" tuiButton appearance="textfield" size="m"
                                            class="rounded-0 text-dark bg-transparent light-btn-hover"
                                            iconStart="@tui.pencil-line">
                                            Edit Details
                                        </button>
                                    </div>
                                    <div class="text-muted mt-3 md-block hidden">
                                        <div class="d-flex">
                                            <div class="col px-0">
                                                <p class="text-[12px] mb-0">Application Date</p>
                                                <p class="text-[14px] mb-2">{{convertToDate(uploadedFiles[k].trialAssetsDetails.applyStorenCornDate)}}</p>
                                            </div>
                                            <div class="col px-0">
                                                <p class="text-[12px] mb-0">Date Taken</p>
                                                <p class="text-[14px] mb-2">{{convertToDate(uploadedFiles[k].trialAssetsDetails.dateOfPhoto)}}</p>
                                            </div>
                                            <div class="col px-0">
                                                <p class="text-[12px] mb-0">Use Rate</p>
                                                <p class="text-[14px] mb-2">{{uploadedFiles[k].trialAssetsDetails.storenUseRate}} qt/A</p>
                                            </div>
                                        </div>
                                        <div class="d-flex">
                                            <div class="col px-0">
                                                <p class="text-[12px] mb-0">City/Town</p>
                                                <p class="text-[14px] mb-2">{{uploadedFiles[k].trialAssetsDetails.storenNearestCity}}</p>
                                            </div>
                                            <div class="col px-0">
                                                <p class="text-[12px] mb-0">State</p>
                                                <p class="text-[14px] mb-2">{{uploadedFiles[k].trialAssetsDetails.storenState}}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="text-muted mt-3 row">
                                        <div class="d-flex mobileApp">
                                            <div class="col px-0">
                                                <p class="text-[12px] mb-0">Application Date</p>
                                                <p class="text-[14px] mb-2">{{convertToDate(uploadedFiles[k].trialAssetsDetails.applyStorenCornDate)}}</p>
                                            </div>
                                            <div class="col px-0">
                                                <p class="text-[12px] mb-0">Date Taken</p>
                                                <p class="text-[14px] mb-2">{{convertToDate(uploadedFiles[k].trialAssetsDetails.dateOfPhoto)}}</p>
                                            </div>
                                            <div class="col px-0">
                                                <p class="text-[12px] mb-0">Use Rate</p>
                                                <p class="text-[14px] mb-2">{{uploadedFiles[k].trialAssetsDetails.storenUseRate}} qt/A</p>
                                            </div>
                                        </div>
                                        <div class="d-flex">
                                            <div class="col px-0">
                                                <p class="text-[12px] mb-0">City/Town</p>
                                                <p class="text-[14px] mb-2">{{uploadedFiles[k].trialAssetsDetails.storenNearestCity}}</p>
                                            </div>
                                            <div class="col px-0">
                                                <p class="text-[12px] mb-0">State</p>
                                                <p class="text-[14px] mb-2">{{uploadedFiles[k].trialAssetsDetails.storenState}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>

                        <div class="image_metadata-container" *ngIf="file.isReadonly && file.isDeleted">
                            <!-- <div class="row mx-0 p-3">
                                <div class="col-md-6 col-4 bg-secondary">
                                    <img [src]="file.fileUrl" controls class="preview-image">
                                </div> -->
                                <div class="row mx-0 p-3">
                                    <div class="col-md-6 col-4 bg-secondary image-container mb-img" [class.video]="file.isVideo"
                                      [class.image]="!file.isVideo">
                                      <tui-icon *ngIf="file.isVideo" class="position-absolute"
                                        style="top: 10px; left: 10px; z-index: 1; padding: 8px; border-radius: 50%; " size="s"
                                        icon="@tui.video">
                                      </tui-icon>
                                      <tui-icon *ngIf="!file.isVideo" class="position-absolute"
                                        style="top: 10px; left: 10px; z-index: 1; padding: 8px; border-radius: 50%; " size="s"
                                        icon="@tui.image">
                                      </tui-icon>
                                      <img [src]="file.fileUrl" controls class="preview-image">
                                    </div>
                                <div class="col-md-6 col-8">
                                    <div class="d-flex justify-content-between text-muted" style="overflow-wrap: anywhere;">                          
                                        <div class="file-name-wrap" class="col-9 pl-0 pr-0">{{file.fileName}}</div>
                                        <div class="col-3 pr-0" style="font-weight:800;">{{k+1}} of {{uploadedFiles.length}}</div>
                                    </div>
                                    <div class="my-md-4 mt-5">
                                        <p class="text-[16px] mb-2"  *ngIf="file.isVideo">Video deleted.</p>
                                        <p class="text-[16px] mb-2" *ngIf="!file.isVideo">Image deleted.</p>
                                        <p class="text-[12px] mb-2 md:block hidden">This item will be deleted
                                            permanently if you leave this page.</p>
                                        <button (click)="editDetails(k)" tuiButton appearance="textfield" size="m"
                                            class="rounded-0 text-dark bg-transparent light-btn-hover"
                                            iconStart="@tui.rotate-ccw">
                                            Restore 
                                        </button>
                                    </div>
                                    <!--Edit Details Preview fields Name-->
                                    <!-- <div class="text-muted mt-3 d-md-block d-none">
                                        <div class="d-flex">
                                          <div class="col px-0">
                                            <p class="acp-fs-12 mb-0">Application Date</p>
                                            <p class="acp-fs-14 mb-2">{{uploadedFiles[k].trialAssetsDetails.applyStorenCornDate}}</p>
                                          </div>
                                          <div class="col px-0">
                                            <p class="acp-fs-12 mb-0">Date Taken</p>
                                            <p class="acp-fs-14 mb-2">{{uploadedFiles[k].trialAssetsDetails.dateOfPhoto}}</p>
                                          </div>
                                          <div class="col px-0">
                                            <p class="acp-fs-12 mb-0">Use Rate</p>
                                            <p class="acp-fs-14 mb-2">{{uploadedFiles[k].trialAssetsDetails.storenUseRate}} qt/A</p>
                                          </div>
                                        </div>
                                        <div class="d-flex">
                                          <div class="col px-0">
                                            <p class="acp-fs-12 mb-0">City/Town</p>
                                            <p class="acp-fs-14 mb-2">{{uploadedFiles[k].trialAssetsDetails.storenNearestCity}}</p>
                                          </div>
                                         
                                        </div>
                                        
                                      </div> -->
                                  
                                    <!--Edit Details Preview fields Name-->
                                </div>
                            </div>
                            <div class="row mx-0 p-3 md:hidden block">
                                <p class="text-[12px] mb-2 md:block hidden">This item will be deleted permanently if
                                    you leave this page.</p>
                            </div>
                        </div>
                    </ng-container>
                        <div class="tui-form__row marginStyle">
                            <div class="tui-form__buttons w-full mt-0 px-0">
                                <button size="m" tuiButton appearance="primary-grayscale" type="button"
                                    (click)="confirmAndSubmitAssets()"  [disabled]="isCheckAllFields()"
                                    class="tui-form__button1 rounded-0 send-consent-btn w-100 dark-btn-hover">
                                    Confirm &amp; Submit Assets
                                </button>
                            </div>
                        </div>

                    </div>
                
                </div>
            </form>
            <section class="bg-white mb-5" *ngIf="current_upload_inner_step === 3">
                <div class="row mt-5" id="cleanRowThanks">
                    <div class="mx-auto">
                        <div class="text-center">
                            <div class="my-4 flex justify-center items-center">
                                <img src="../assets/Check.png" alt="" class="w-[92px] h-[92px]">
                            </div>
                            <div class="my-4">
                                <p class="text-[36px] font-bold leading-[37px]">Almost Done!</p>
                                <div class="flex flex-col gap-2 mt-4 text-neutral-500" id="cleanRowThanks">
                                    <p class="text-[16px] leading-[24px]">Thank you for your submission! You're all
                                        set
                                        for now, but there's more to come.</p>
                                    <p class="text-[16px] leading-[24px]">This fall, we’ll email you when it’s time
                                        to
                                        submit your End-of-Season survey.</p>
                                    <p class="text-[16px] leading-[24px] mt-4">Once you submit your Satisfaction Survey,
                                        you’ll
                                        have
                                        the opportunity to choose your reward—a Storen-branded hat or beanie.</p>
                                    <p class="text-[16px] leading-[24px]">Thank
                                        you
                                        for your participation in the Storen Satisfaction Program.</p>
                                </div>
                            </div>
                        </div>
                        <div class="m-3 mt-5">
                            <button (click)="goToEndOfSeasonSurvey()" tuiButton appearance="primary-grayscale" size="m"
                                class="rounded-0 text-white w-100 dark-btn-hover dark-btn-hover">
                                Return to Dashboard
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </section>
    </main>
</tui-root>